import { hbs } from 'ember-cli-htmlbars';

export default {
  title: 'Home/MwHomeFooter',
  component: 'MwHomeFooter',
};

const Template = () => ({
  template: hbs`<Home::MwHomeFooter />`,
  context: {},
});

export const Default = Template.bind({});
